import React from 'react';
import { formatCurrency, calculateFinalAmount } from '../../utils/calculations';

const OrderSummary = ({ 
  order, 
  totalAmount, 
  serviceCharge, 
  taxPercentage, 
  taxAmount,
  offerDiscount = 0,
  onIncreaseQuantity,
  onDecreaseQuantity,
  onRemoveItem 
}) => {
  if (order.length === 0) {
    return <p className="text-sm text-stone-500">No items added yet.</p>;
  }

  const finalAmount = calculateFinalAmount(totalAmount, taxAmount, serviceCharge) - offerDiscount;

  return (
    <div className="min-w-0 overflow-hidden space-y-3">
      <div className="rounded-xl border border-stone-200 bg-white p-3 sm:p-4">
        <ul className="space-y-3">
          {order.map((item, idx) => (
            <li key={idx} className="min-w-0 border-b border-stone-100 pb-3 last:border-b-0 last:pb-0">
              <div className="flex items-start justify-between gap-2 min-w-0">
                <div className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-semibold text-stone-900">
                    {item.name}
                  </span>
                  <span className="mt-0.5 inline-flex items-center rounded-full bg-stone-50 px-2 py-0.5 text-[11px] font-medium text-stone-600">
                    Qty: {item.quantity}
                  </span>
                </div>
                <span className="flex-shrink-0 text-sm font-bold text-amber-600">
                  {formatCurrency(item.price * item.quantity)}
                </span>
              </div>
              <div className="mt-2 flex items-center gap-2">
                <div className="inline-flex items-center rounded-full border border-stone-200 bg-stone-50 px-1">
                  <button
                    type="button"
                    onClick={() => onDecreaseQuantity(item.itemId)}
                    className="w-7 h-7 flex items-center justify-center rounded-full text-sm font-semibold text-stone-700 hover:bg-stone-200 transition"
                    aria-label="Decrease quantity"
                  >
                    –
                  </button>
                  <div className="w-px h-4 bg-stone-200" />
                  <button
                    type="button"
                    onClick={() => onIncreaseQuantity(item.itemId)}
                    className="w-7 h-7 flex items-center justify-center rounded-full text-sm font-semibold text-stone-700 hover:bg-stone-200 transition"
                    aria-label="Increase quantity"
                  >
                    +
                  </button>
                </div>
                <button
                  type="button"
                  onClick={() => onRemoveItem(item.itemId)}
                  className="ml-auto inline-flex items-center justify-center px-3 py-1.5 rounded-full text-[11px] font-semibold border border-red-200 text-red-600 bg-red-50 hover:bg-red-100 transition"
                >
                  Remove
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-stone-50 border border-stone-200 rounded-xl p-3 sm:p-4 space-y-1.5">
        <div className="flex justify-between text-sm">
          <span className="text-stone-600">Base Total</span>
          <span className="font-medium text-stone-800">{formatCurrency(totalAmount)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-stone-600">Tax ({taxPercentage}%)</span>
          <span className="font-medium text-stone-800">{formatCurrency(taxAmount)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-stone-600">Platform Fees</span>
          <span className="font-medium text-stone-800">{formatCurrency(serviceCharge)}</span>
        </div>
        {offerDiscount > 0 && (
          <div className="flex justify-between text-sm text-amber-600">
            <span>Offer Discount</span>
            <span className="font-medium">−{formatCurrency(offerDiscount)}</span>
          </div>
        )}
        <div className="flex justify-between text-sm font-bold border-t border-stone-200 pt-2 mt-2">
          <span className="text-stone-800">Final Total</span>
          <span className="text-amber-600">{formatCurrency(finalAmount)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;